<template>
  <main class="dewars">
    <div class="dewars-banner">
      <div class="container">
        <div class="dewars-banner__ban">
          <img
            src="/dewars/ban.png"
            alt=""
          />
        </div>
        <div class="dewars-banner__info">
          <h1>{{ $t("dewars.banner.title") }}</h1>
          <h2>{{ $t("dewars.banner.subtitile") }}</h2>
          <p>{{ $t("dewars.banner.timer") }}</p>
          <div class="dewars-banner__timer">
            <div class="dewars-banner__timer-item">
              <p>{{ timer.days }}</p>
              <span>{{ $t("dewars.banner.day") }}</span>
            </div>
            <span class="line">:</span>
            <div class="dewars-banner__timer-item">
              <p>{{ timer.hours }}</p>
              <span>{{ $t("dewars.banner.th") }}</span>
            </div>
            <span class="line">:</span>
            <div class="dewars-banner__timer-item">
              <p>{{ timer.minutes }}</p>
              <span>{{ $t("dewars.banner.min") }} </span>
            </div>
            <span class="line">:</span>
            <div class="dewars-banner__timer-item">
              <p>{{ timer.seconds }}</p>
              <span>{{ $t("dewars.banner.sec") }}</span>
            </div>
          </div>
        </div>
        <div class="dewars-banner__img">
          <img
            src="/dewars/banner.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="dewars-ruls">
      <div class="container">
        <div class="dewars-ruls__title mob">
          <h1>{{ $t("dewars.banner.title") }}</h1>
          <h2>{{ $t("dewars.banner.subtitile") }}</h2>
        </div>
        <img
          src="/dewars/ruls.png"
          alt=""
        />
        <div class="dewars-ruls__info">
          <h2>{{ $t("dewars.ruls.title") }}</h2>
          <div>
            <p v-html="$t('dewars.ruls.desc')"></p>
          </div>
          <!-- <p>Будь участником Magnum Party Club.</p>
          <p>В течение трех месяцев купи три бутылки Dewar’s:</p>
          <ul>
            <li>Dewar’s 12-летней выдержки;</li>
            <li>Dewar’s Caribbean 8-летней выдержки;</li>
            <li>Dewar’s Portuguese 8-летней выдержки.</li>
          </ul>
          <p>
            Стань обладателем фирменного рюкзака путешественника с брендированной флягой и
            подарочной бутылкой Dewar’s 12-летней выдержки*
          </p> -->
          <a
            :href="
              $i18n.locale === 'ru'
                ? info.attributes.link_to_rules || '#'
                : info.attributes.localizations.attributes.link_to_rules || '#'
            "
            target="_blank"
            rel="noopener noreferrer"
          >
            <button>{{ $t("dewars.btn") }}</button>
          </a>
          <span class="tag">{{ $t("dewars.ruls.subdesc") }}</span>
        </div>
      </div>
    </div>
    <div class="dewars-history">
      <div class="container">
        <div class="dewars-history__info">
          <h3 v-html="$t('dewars.video.title')"></h3>
          <p>{{ $t("dewars.video.text") }}</p>
          <div class="deck">
            <span class="tag">{{ $t("dewars.video.subtext") }}</span>
            <a
              href="http://dewars.esquire.kz/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button>{{ $t("dewars.btn") }}</button>
            </a>
          </div>
        </div>
        <div class="dewars-history__video">
          <iframe
            src="https://player.vimeo.com/video/989931025?h=fc7510210a"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen
          ></iframe>
          <!-- <p>
            <a href="https://vimeo.com/989931025"
              >DEWAR&#039;S Легендарные истории должны быть рассказаны.</a
            >
            from <a href="https://vimeo.com/user223384757">Alexey Kim</a> on
            <a href="https://vimeo.com">Vimeo</a>.
          </p> -->
        </div>

        <div class="mob">
          <a
            href="http://dewars.esquire.kz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button>{{ $t("dewars.btn") }}</button>
          </a>

          <span class="tag">{{ $t("dewars.video.subtext") }}</span>
        </div>
      </div>
    </div>
    <div class="dewars-products">
      <div class="container">
        <h2
          class="deck"
          v-html="$t('dewars.product.title')"
        ></h2>
        <h2
          class="mob"
          v-html="$t('dewars.product.titlemob')"
        ></h2>
        <div
          class="dewars-products__slider"
          :style="sl"
          v-if="isSlider"
        >
          <div class="prev">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              @click="prevSlide()"
              :style="isMob && productActive ? `z-index: 0; display: none;` : ''"
            >
              <circle
                cx="22"
                cy="22"
                r="22"
                transform="rotate(-180 22 22)"
                fill="#422B2B"
              />
              <path
                d="M24.5382 30.4615L16.0767 21.9999L24.5382 13.5384"
                stroke="white"
                stroke-width="2"
                stroke-linecap="square"
              />
            </svg>
          </div>
          <div>
            <swiper
              ref="swiperRef"
              :options="swiperOption"
              class="swiper"
            >
              <swiper-slide
                v-for="(item, i) in getProduct()"
                :key="i"
              >
                <div
                  class="dewars-products__item"
                  :key="i"
                  @click="
                    isMob
                      ? (productActive = productActive ? null : i)
                      : (productActive = productActive === i ? null : i)
                  "
                >
                  <div
                    :class="`dewars-products__item-img ${
                      productActive === i || (productActive && isMob) ? 'active' : ''
                    }`"
                  >
                    <img
                      v-if="productActive === i || (productActive && isMob)"
                      src="/dewars/bgp.png"
                      class="slug"
                      alt=""
                    />
                    <img
                      :src="productActive === i || (productActive && isMob) ? item.imga : item.img"
                      alt=""
                      style="z-index: 9"
                    />
                    <div
                      v-if="productActive === i || (productActive && isMob)"
                      class="dewars-products__item-desc"
                      style="z-index: 9"
                    >
                      <p v-html="item.description"></p>
                    </div>
                  </div>
                  <p v-if="isMob ? !productActive : productActive !== i">
                    {{ item.name }}
                  </p>
                </div>
              </swiper-slide>
            </swiper>
          </div>

          <div class="next">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              @click="nextSlide()"
              :style="isMob && productActive ? `z-index: 0; display: none;` : ''"
            >
              <circle
                cx="22"
                cy="22"
                r="22"
                fill="#422B2B"
              />
              <path
                d="M19.4618 13.5384L27.9233 21.9999L19.4618 30.4615"
                stroke="white"
                stroke-width="2"
                stroke-linecap="square"
              />
            </svg>
          </div>
        </div>
      </div>
      <img
        src="/dewars/item.png"
        alt=""
        class="element"
      />
    </div>
  </main>
</template>

<script>
import axios from "@/plugins/axios"
// import {
//   getQuestionnaire,
//   questionnairesCheckUser,
//   questionnairesEndTest,
//   questionnaireResponse,
// } from "@/api/questionnaire"
export default {
  name: "DewarsPage",
  data() {
    return {
      info: null,
      timer: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      isMob: false,
      isSlider: true,
      swiperOption: {
        spaceBetween: 85,
        // lazy: true,
        slideTo: 2,
        // loop: true,
        // spaceBetween: ,
        initialSlide: 1,
        centeredSlides: true,
        // responsive: true,

        breakpoints: {
          600: {
            slidesPerView: 2,
            spaceBetween: 85,
          },
          800: {
            slidesPerView: 3,
            spaceBetween: 85,
          },
          1000: {
            slidesPerView: 3,
          },
        },
      },
      productActive: null,
      product: [
        {
          id: 1,
          name: `Dewar's 12 Years Old`,
          img: "/dewars/p1.png",
          imga: "/dewars/ph1.png",
          description: `<b>Dewar's 12 Years OLD</b><div class="br"></div>Вкус 12-летнего DEWAR'S подобен симфоническому оркестру. Его бленд составляют более сорока солодовых и зерновых виски, каждый из которых ведет свою партию и в сочетании с другими создает неповторимую, присущую только DEWAR'S композицию. Цвет этого виски глубокий, насыщенно-янтарный, а в его зрелом фруктовом аромате чувствуются ноты кишмиша, изюма, апельсиновой цедры и глазированных сладких яблок, смешанные с нотками карамели, палочек ванили и легким ароматом шотландского вереска. Аромат одновременно насыщенный, мягкий и сбалансированный.  Своими неповторимыми вкусовыми качествами виски обязан уникальной технологии двойной выдержки или, как называют ее в компании Dewar's, «женитьбы», придуманной Мастером купажа Александром Кэмероном в 1890-х годах. Это запатентованная технология, согласно которой после первичного смешивания лучших односолодовых и зерновых виски их снова помещают в дубовые бочки, где они выдерживаются еще примерно полгода, приобретая новые качества.  Когда изготавливается 12-летний DEWAR'S, смешиваются виски сроком выдержки не менее 12 лет (некоторые из них и старше). Затем их помещают в старые 40-летние хересные бочки, где они дожидаются своего часа. Процесс женитьбы может занимать 4, 5, 6 месяцев – степень готовности купажа определяет Мастер купажа DEWAR'S Стефани Маклеод.`,
        },
        {
          id: 2,
          name: `Dewar's PORTUGUESE Smooth 8 Years Old`,
          img: "/dewars/p2.png",
          imga: "/dewars/ph2.png",
          description: `<b>Dewar's Portuguese Smooth 8 Years OLD</b> - Купажированный шотландский виски восьмилетней выдержки, праздник двух культур: Португалии и Шотландии, воплощающий яркость и красочность вкуса обеих стран.<div class="br"></div> Купаж виски состоит из около 40 различных односолодовых и зерновых виски. Финишная выдержка в бочках из-под португальского портвейна наделяет виски неповторимыми нотками спелых красных фруктов и пряностей, а также характерной танинностью, которая присуща красным винам и делает вкус виски более насыщенным и уникальным.`,
        },
        {
          id: 3,
          name: `Dewar's Caribbean Smooth 8 Years Old`,
          img: "/dewars/p3.png",
          imga: "/dewars/ph3.png",
          description: `<b>Dewar's CARIBBEAN Smooth 8 Years OLD</b> — Купажированный шотландский виски восьмилетней выдержки. Особенностью, а точнее — "изюминкой", этого виски является то, что выдержка осуществляется в бочках, ранее использовавшихся для выдержки карибского рома. Такая технология придает напитку дополнительную мягкость и интригующий вкус с нюансами тропических фруктов и карамели. Идеально подходит для употребления в чистом виде со льдом, а также в коктейлях.`,
        },
      ],
      productkz: [
        {
          id: 1,
          name: `Dewar's 12 Years Old`,
          img: "/dewars/p1.png",
          imga: "/dewars/ph1.png",
          description: `<b>Dewar's 12 Years OLD</b><div class="br"></div>12 жылдық DEWAR'S дәмі симфониялық оркестрге ұқсайды. Оның бленді қырықтан астам уыт пен дәнді вискиден тұрады, олардың әрқайсысы өз партиясын басқарады және басқалармен үйлесімде тек DEWAR'S-қа тән ерекше композиция жасайды.<div class="br"></div>Бұл вискидің терең, қанық кәріптас түсі бар, оның жетілген жеміс хош иісінде карамель, ваниль таяқшалары мен шотландтық көкбұтаның жеңіл хош иісімен араласқан кішміш, мейіз, апельсин қабығы және әйнекейленген тәтті алма ноталары сезіледі. Хош иіс қанық, жұмсақ әрі теңгерімді.<div class="br"></div>Виски өзінің ерекше дәмдік қасиеттері үшін екі есе көп сақталатын немесе 1890 жылдары купаж шебері Александр Кэмерон ойлап тапқан Dewar's компаниясында "үйлену" деп аталатын бірегей технологиясына қарыздар. Бұл ең жақсы біруытты және дәнді вискилерді бастапқы араластырғаннан кейін оларды еменнен жасалған бөшкелерге қайта құйып қоятын патенттелген технология, онда олар тағы алты ай сақталады да, жаңа қасиеттерге ие болады.<div class="br"></div> 12 жылдық  Dewar's жасалған кезде ең кемінде 12 жыл сақталған вискимен араластырылады (олардың кейбіреулері одан да ұзақ сақталған). Содан кейін оларды 40 жылдық херес бөшкелеріне құяды да, онда олар бабына жеткенше күтеді. "Үйлену" процесі 4, 5, 6 айға созылуы мүмкін – купаждың дайын болу дәрежесін DEWAR'S купажының шебері Стефани Маклеод анықтайды.`,
        },
        {
          id: 2,
          name: `Dewar's PORTUGUESE Smooth 8 Years Old`,
          img: "/dewars/p2.png",
          imga: "/dewars/ph2.png",
          description: `<b>Dewar's Portuguese Smooth 8 Years OLD</b> - сегіз жылдық купаждалған шотланд вискиі, екі мәдениеттің мерекесі: Португалия мен Шотландия, екі елдің де жарқын әрі әсем дәмін бейнелейді. Виски купажы шамамен 40 түрлі біруытты және дәнді вискиден тұрады. Португалдық портвейн бөшкелерінде сақталуы вискиге піскен қызыл жемістер мен дәмдеуіштердің ерекше ноталарын, сондай-ақ қызыл шараптарға тән және вискидің дәмін қанық әрі бірегей ететін ерекше ауыз қуыратын сипат береді.`,
        },
        {
          id: 3,
          name: `Dewar's Caribbean Smooth 8 Years Old`,
          img: "/dewars/p3.png",
          imga: "/dewars/ph3.png",
          description: `<b>Dewar's CARIBBEAN Smooth 8 Years OLD</b> — сегіз жыл сақталған купаждалған шотланд вискиі. Бұл вискидің ерекшелігі, дәлірек айтқанда, "өзіндік кереметі" — бұрын Кариб ромын сақтау үшін қолданылған бөшкелерде сақталатынында. Мұндай технология сусынға қосымша жұмсақтық пен тропиктік жемістер мен карамельдің нюанстарымен қызықтыратын дәм береді.Мұз қосқан таза түрінде, сондай-ақ коктейльдерге де қосып ішуге болады.`,
        },
      ],
      // slugs: [
      //   {
      //     slug: "pmk",
      //     id: 1,
      //   },
      // ],
      // progress: 1,
      // selected: null,
      // selectedList: [],
      // isShowPreview: true,
      // isShowQuestion: false,
      // isShowEnd: false,
      // isShowFalse: false,
      // isShowSucces: false,
      // survey: null,
      // error: false,
      // isManyAnswers: false,
      // user: null,
    }
  },
  computed: {
    swiper() {
      return this.$refs?.swiperRef
    },
  },
  created() {
    axios.get(`/promos/83?populate[localizations]=%2A`).then((res) => {
      this.info = res.data.data
      if (this.info && res?.data?.data?.attributes?.localizations?.data?.length) {
        this.info.attributes.localizations = this.info.attributes?.localizations.data[0]
      }
    })
  },
  mounted() {
    this.Timer()
    this.isMob = window.innerWidth < 500
    window.addEventListener("resize", function () {
      this.isMob = window.innerWidth < 500
    })
    // this.sl = "display: flex"
    // let routePath = this.$route.path.split("-")
    // if (routePath.length >= 2) {
    //   let id = this.slugs.find((e) => e.slug == routePath[1]).id
    //   getQuestionnaire(id).then((res) => {
    //     this.survey = res
    //   })
    // } else {
    //   getQuestionnaire(1).then((res) => {
    //     this.survey = res
    //   })
    // }
    // if (this.$route.query.q) {
    //   let q = this.$route.query.q.split(" ")
    //   this.user = {
    //     card: q[0],
    //     phone: q[1],
    //     test: 1,
    //   }
    //   questionnairesCheckUser(this.user).then((res) => {
    //     if (!res.isTest) {
    //       this.isShowPreview = false
    //       this.isShowSucces = true
    //     }
    //   })
    // } else {
    //   this.$router.push("/")
    // }
  },
  watch: {
    // progress: {
    //   handler() {
    //     this.error = false
    //     window.scrollTo(0, 0, "smooth")
    //   },
    // },
    // selected: {
    //   deep: true,
    //   handler() {
    //     this.error = false
    //   },
    // },
    // "selectedList.length": {
    //   handler() {
    //     this.error = false
    //   },
    // },
  },
  methods: {
    Timer() {
      var t = Date.parse(new Date("2025-02-09")) - Date.parse(new Date())
      this.timer.seconds = Math.floor((t / 1000) % 60)
      this.timer.minutes = Math.floor((t / 1000 / 60) % 60)
      this.timer.hours = Math.floor((t / (1000 * 60 * 60)) % 24)
      this.timer.days = Math.floor(t / (1000 * 60 * 60 * 24))
      setTimeout(() => this.Timer(), 1000)
    },
    getProduct() {
      console.log(this.$i18n.locale)

      let arr = []
      const prod = this.$i18n.locale === "ru" ? this.product : this.productkz
      for (let i = 0; i < 10; i++) {
        arr = [...arr, ...prod]
      }
      return arr
    },
    prevSlide() {
      this.swiper?.swiperInstance.slidePrev()
    },
    rerender() {
      // if (this.isMob) {
      //   this.isSlider = false
      //   setTimeout(() => {
      //     this.isSlider = true
      //   }, 10)
      // }
    },
    nextSlide() {
      this.swiper.swiperInstance.slideNext()
    },
    // showQuestion() {
    //   this.isShowPreview = false
    //   this.isShowQuestion = true
    // },
    // showEnd() {
    //   this.isShowQuestion = false
    //   this.isShowEnd = true
    // },
    // showFalse() {
    //   this.isShowQuestion = false
    //   this.isShowFalse = true
    // },
    // nextPage() {
    //   if (this.isManyAnswers ? !this.selectedList.length : !this.selected) {
    //     this.error = true
    //     window.scrollTo(0, 0, "smooth")
    //     return
    //   }
    //   let questionnaire = {
    //     phone: this.user?.phone,
    //     card: this.user?.card,
    //     test_id: 1,
    //     question_id: this.survey.question[this.progress - 1].id,
    //   }
    //   if (this.isManyAnswers) {
    //     questionnaire.answers = this.selectedList.map((e) => e.label)
    //     questionnaireResponse(questionnaire)
    //     if (this.selectedList.length === 1 && this.selectedList.find((e) => e.label === "Сигареты")) {
    //       this.progress = this.selectedList.find((e) => e.label === "Сигареты")?.next_order
    //     } else {
    //       this.progress = this.selectedList.filter((e) => e.label !== "Сигареты")[0]?.next_order
    //     }
    //     this.selectedList = []
    //     this.isManyAnswers = false
    //   } else {
    //     questionnaire.answers = this.selected.label
    //     questionnaireResponse(questionnaire)
    //     if (this.selected?.end) {
    //       this.selected = null
    //       if (this.progress == 1 || this.progress == 2) {
    //         this.showFalse()
    //         return
    //       }
    //       this.showEnd()
    //       return
    //     }
    //     if (this.selected?.next_order) {
    //       if (this.survey.question.findIndex((e) => e.order_id === this.selected.next_order)) {
    //         this.progress =
    //           this.survey.question.findIndex((e) => e.order_id === this.selected.next_order) + 1
    //       }
    //       this.selected = null
    //       return
    //     }
    //     if (this.progress != 7) {
    //       this.progress++
    //     } else {
    //       this.showEnd()
    //     }
    //   }
    //   this.selected = null
    //   this.selectedList = []
    //   this.isManyAnswers = false
    // },
    // getImage(image) {
    //   const urlImg = image
    //   if (urlImg) {
    //     return this.$helpers.getAbsolutePath(urlImg)
    //   }
    // },
    // getActive(item) {
    //   if (this.isManyAnswers) {
    //     return this.selectedList.findIndex((e) => e.id === item.id) != -1 ? true : false
    //   } else {
    //     return this.selected ? item.id == this.selected.id : false
    //   }
    // },
    // selectedItem(survey, item) {
    //   if (survey.mani_answers) {
    //     this.isManyAnswers = true
    //     // if (
    //     //   this.selectedList.length &&
    //     //   this.selectedList.find((e) => e.next_order !== item.next_order)
    //     // ) {
    //     //   this.selectedList = []
    //     // }
    //     if (this.selectedList.findIndex((e) => e.id === item.id) == -1) {
    //       this.selectedList.push(item)
    //     } else {
    //       this.selectedList.splice(
    //         this.selectedList.findIndex((e) => e.id === item.id),
    //         1,
    //       )
    //     }
    //     return
    //   }
    //   if (this.selected?.id === item.id) {
    //     this.selected = null
    //   } else {
    //     this.selected = item
    //   }
    // },
    // finishedSurvey() {
    //   questionnairesEndTest(this.user).then((res) => {
    //     if (res.end) {
    //       window.location.href = this.survey.link
    //       return
    //     }
    //     if (res.error) {
    //       alert(res.error)
    //     }
    //   })
    // },
  },
}
</script>

<style
  lang="scss"
  scoped
></style>
